module.exports = require('./src/ScrollLock');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/github.com+petflow+react-scrolllock@7b8a03b87ef422bbffc9610ddc35028b8a5ba96d_react@15.7.0/~/react-scrolllock/index.js
// module id = 355
// module chunks = 0